module.exports = __webpack_public_path__ + "img/banner-3-2.56265f06.png";